<template>
  <div class="tw-flex tw-min-h-screen tw-flex-col tw-bg-gray-50">
    <div class="safe-area-top tw-rounded-b-[30px]" :class="headerNav">
      <HeaderNav />
      <div
        class="tw-hidden tw-h-0.5 tw-w-full tw-border-b tw-border-white tw-border-opacity-20 lg:tw-block"
      />
      <div
        class="tw-rounded-b-[30px] tw-bg-gradient-to-b"
        :class="[linearGradient, cobrandedExperience ? 'xs:tw-h-52 lg:tw-h-48' : 'xs:tw-h-52']"
      />
    </div>
    <div class="tw-relative tw-flex tw-flex-1 tw-items-start tw-justify-center">
      <section
        v-show="!isLoading"
        class="tw--mt-44 tw-w-full tw-rounded-lg tw-px-6 lg:tw-w-3/4 lg:tw-p-0"
      >
        <DashboardTracker />
        <div class="tw-min-h-full md:tw-flex">
          <main class="tw-relative tw-flex tw-flex-1 tw-flex-col tw-overflow-visible">
            <slot />
          </main>
        </div>
      </section>
    </div>

    <!-- Desktop footer -->
    <div class="tw-flex tw-w-full tw-items-center tw-justify-center">
      <AuthenticatedFooter class="tw-hidden lg:tw-block lg:tw-w-3/4" />
    </div>

    <!-- Tablet and mobile navigation -->
    <div
      class="safe-area-bottom tw-fixed tw-bottom-0 tw-w-full tw-border-t-2 tw-border-gray-200 tw-bg-white lg:tw-hidden"
    >
      <Navigation class="tw-h-[72px]" />
    </div>

    <AppToast />
  </div>
</template>

<script setup lang="ts">
import { ActionRequestStatus } from '@torticity/types'

const query1 = useClaimStatusQuery()
const query2 = useActionRequestsQuery(null, [ActionRequestStatus.PENDING_USER_ACTION])

const branding = useBrand()
const cobrandedExperience = computed(() => branding.value.brandingExperience === 'cobrand')

const isLoading = computed(() => !query1.isFetched.value && !query2.isFetched.value)
const { getThemeTokenString } = useTheme()
const linearGradient = getThemeTokenString('linear-gradient')
const headerNav = getThemeTokenString('header-nav')

onMounted(() => {
  localStorage.removeItem('flow')
})
</script>

<style scoped>
.safe-area-top {
  padding-top: calc(env(safe-area-inset-top) - 12px);
}

.safe-area-bottom {
  padding-bottom: calc(env(safe-area-inset-bottom) / 3);
}
</style>
